import React, {useState} from "react";
import {Section, Addon, Subscription_addon_popup} from '../../../components';
import {Grid,Typography,IconButton,Divider,Paper,Button, useTheme} from "@material-ui/core";
import { Edit as EditIcon, Add as AddIcon, Extension as ExtensionIcon } from "@material-ui/icons";
import axios from 'axios';


function AddonSection(props){
  const[subscription_plus, setSubscriptionPlus]=useState();
  let current_subscription=props.current_subscription;
  let period='month';
  if(current_subscription.subscription_interval=='YEAR'){period='year';}
  if(current_subscription==undefined || current_subscription.type=='FREE' || current_subscription.type==undefined){return null;}
  let addons=[];
  if(props.subscriptions!=undefined){
    for(let s of props.subscriptions){
      if(s.type=='SUBSCRIPTION_PLUS' && s.subscription_interval==current_subscription.subscription_interval && (s.level==null || s.level==current_subscription.level)){
        let active=false;
        for(let ae of props.active_subscription.active_subscription_extras){if(ae.prospect_safari_service_id==s.id){active=true;}}
        if((s.rec=='GSMC' && props.workspace.gsmc_flag==false) || (s.rec=='SMC' && props.workspace.gsmc_flag==true)){}else{
          if(active==false && (s.rec=='PRL' || s.rec=='SMC' || s.rec=='GSMC')){}
          else if(active==false){addons.unshift({...s, currently_active:active});}else{addons.push({...s, currently_active:false});}
        }
  }}}
  console.log(addons, 'ADDONS');
  if(addons.length==0){return(null);}
  return(
    <Section icon={<ExtensionIcon color='secondary'/>} title='Custom Plugins' maxWidth='600px'>
      <Grid container style={{width:'100%'}}>
      {addons.map(function(s){//https://pieregister.com/wp-content/uploads/2020/01/bulk-mail-addon.jpg
        return(<Grid item xs={12} style={{display:'flex', justifyContent:'center', alignItems:'center', marginTop:'10px', marginBottom:'10px'}}><div style={{width:'calc(100% - 20px)', marginLeft:'0px'}}><Addon isActive={s.currently_active} onClick={()=>{if(props.disable==true){props.setRestore(true);}else{setSubscriptionPlus(s);}}} addon={{name:s.name, interval:s.subscription_interval, image:s.image_url, description:s.description, price:s.currency+s.amount, topup:s.credits, isActive:s.currently_active}}/></div></Grid>)
      })}
      </Grid>
      {(subscription_plus==undefined)?null:<Subscription_addon_popup {...props} ps={subscription_plus} handleClose={()=>{setSubscriptionPlus(undefined)}}/>}
    </Section>
  )
}

export default AddonSection;
